import { render, staticRenderFns } from "./ExcessiveIdle.vue?vue&type=template&id=09899363&"
import script from "./ExcessiveIdle.vue?vue&type=script&lang=js&"
export * from "./ExcessiveIdle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports